import UserService from '../services/UserService'
import { Fragment } from 'react'
import { Popover, Transition } from '@headlessui/react'
import { MenuIcon, XIcon, ShieldCheckIcon, LockClosedIcon, CollectionIcon } from '@heroicons/react/outline'
import { Link } from 'react-router-dom'
import { launchWhatsAppSignup } from '../helpers/FAcebookSDK'

const navigation = [
    { name: 'Beneficios', href: '#features' },
    { name: 'CoDi', href: '#codi' },
    { name: 'Servicios', href: '#servicios' },
    { name: 'Nosotros', href: '#nosotros' },
]

const features = [
    {
        name: 'Integración simple',
        description:
            'A través de componentes y APIs disponibles es posible integrar la plataforma en tiempos muy cortos y con muy poco esfuerzo de su equipo de desarrollo.',
        icon: ShieldCheckIcon,
    },
    {
        name: 'Identificación automática',
        description: 'Las operaciones de cobro se registran automáticamente ligadas a las transacciones de su negocio.',
        icon: LockClosedIcon,
    },
    {
        name: 'Metadatos',
        description:
            'Datos adicionales pueden ser adjuntados a las operaciones para permitir la generación de analítica y toma de decisiones.',
        icon: CollectionIcon,
    },
]

const blogPosts = [
    {
        id: 1,
        title: 'Puntos de venta',
        href: '#',
        imageUrl: 'pos.jpg',
        preview:
            'Habilite el cobro con CoDi® en sus terminales punto de venta brindando a sus clientes la seguridad de un medio de pago sin contacto.',
    },
    {
        id: 2,
        title: 'Ecommerce',
        href: '#',
        imageUrl: 'ecommerce.jpg',
        preview:
            'Reduzca los costos de su pasarela de pagos integrando el cobro con CoDi® en su tienda en línea, disponible tanto para las principales soluciones comerciales de ecommerce como para desarrollos propios.',
    },
    {
        id: 3,
        title: 'Mejor experiencia de usuario',
        href: '#',
        imageUrl: 'qr.jpg',
        preview:
            'Facilite a sus clientes los pagos integrando nuestra plataforma en sus procesos de cobranza, por ejemplo: créditos, servicios recurrentes, estados de cuenta, etc.',
    },
]

export default function Landing() {
    const login = () => {
        UserService.doLogin()
    }

    return (
        <div className="bg-white">
            <Popover as="header" className="relative z-20">
                <div className="bg-brand-900">
                    <nav className="mx-auto flex max-w-6xl items-center justify-between px-4 py-4 sm:px-6">
                        <img className="h-14 w-auto" src="gotpaywt.svg" alt="GotPay" />
                        <div className="hidden items-center gap-8 md:flex">
                            {navigation.map((item) => (
                                <a key={item.name} href={item.href} className="text-sm font-medium text-slate-200 hover:text-white">
                                    {item.name}
                                </a>
                            ))}
                        </div>
                        <div className="hidden items-center gap-3 md:flex">
                            <button type="button" onClick={login} className="text-sm font-medium text-white hover:text-slate-200">
                                Iniciar sesión
                            </button>
                            <a
                                href="/signup"
                                className="rounded-xl bg-brand-500 px-4 py-2 text-sm font-semibold text-white hover:bg-brand-600"
                            >
                                Regístrate
                            </a>
                        </div>
                        <div className="md:hidden">
                            <Popover.Button className="rounded-lg p-2 text-white">
                                <MenuIcon className="h-6 w-6" />
                            </Popover.Button>
                        </div>
                    </nav>
                </div>
                <Transition
                    as={Fragment}
                    enter="duration-150 ease-out"
                    enterFrom="opacity-0 scale-95"
                    enterTo="opacity-100 scale-100"
                    leave="duration-100 ease-in"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <Popover.Panel className="absolute inset-x-0 top-0 p-2 md:hidden">
                        <div className="rounded-2xl bg-white p-4 shadow-lg">
                            <div className="flex justify-end">
                                <Popover.Button className="p-2 text-slate-500">
                                    <XIcon className="h-5 w-5" />
                                </Popover.Button>
                            </div>
                            {navigation.map((item) => (
                                <a key={item.name} href={item.href} className="block rounded-lg px-3 py-2 text-slate-800">
                                    {item.name}
                                </a>
                            ))}
                            <button type="button" onClick={login} className="mt-2 w-full rounded-xl bg-brand-600 py-2 text-white">
                                Iniciar sesión
                            </button>
                            <a href="/signup" className="mt-2 block w-full rounded-xl border border-slate-200 py-2 text-center text-slate-800">
                                Regístrate
                            </a>
                        </div>
                    </Popover.Panel>
                </Transition>
            </Popover>

            <section className="bg-brand-900">
                <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 lg:py-24">
                    <div>
                        <p className="text-sm font-semibold uppercase tracking-widest text-brand-100">Pagos CoDi</p>
                        <h1 className="mt-3 max-w-2xl text-4xl font-semibold tracking-tight text-white sm:text-5xl">
                            Cobra fácil, seguro y sin comisiones
                        </h1>
                        <p className="mt-5 max-w-xl text-lg text-slate-300">
                            GotPay permite integrar el cobro con CoDi® en puntos de venta, ecommerce y procesos de cobranza.
                        </p>
                        <div className="mt-8 flex gap-3">
                            <a href="/signup" className="rounded-xl bg-brand-500 px-5 py-2.5 text-sm font-semibold text-white hover:bg-brand-600">
                                Crear cuenta
                            </a>
                            <button type="button" onClick={login} className="rounded-xl bg-white/10 px-5 py-2.5 text-sm font-semibold text-white hover:bg-white/20">
                                Iniciar sesión
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            <section id="features" className="mx-auto max-w-6xl px-4 py-20 sm:px-6">
                <h2 className="max-w-2xl text-3xl font-semibold text-slate-900">
                    Todo lo que necesitas para ofrecer un pago práctico y seguro
                </h2>
                <div className="mt-12 grid gap-6 sm:grid-cols-3">
                    {features.map((feature) => (
                        <div key={feature.name} className="rounded-2xl border border-slate-200 p-6">
                            <feature.icon className="h-8 w-8 text-brand-600" />
                            <h3 className="mt-4 text-lg font-semibold text-slate-900">{feature.name}</h3>
                            <p className="mt-2 text-sm text-slate-500">{feature.description}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section id="codi" className="bg-brand-600">
                <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6">
                    <p className="text-sm font-semibold uppercase tracking-widest text-brand-100">CoDi</p>
                    <p className="mt-4 max-w-3xl text-xl text-white">
                        CoDi® es una plataforma de Banco de México para pagos y cobros por transferencias electrónicas, rápidas y
                        disponibles 7x24, mediante códigos QR y mensajes de cobro.
                    </p>
                </div>
            </section>

            <section id="servicios" className="mx-auto max-w-6xl px-4 py-20 sm:px-6">
                <h2 className="text-3xl font-semibold text-slate-900">Servicios</h2>
                <div className="mt-10 grid gap-6 lg:grid-cols-3">
                    {blogPosts.map((post) => (
                        <a key={post.id} href={post.href} className="overflow-hidden rounded-2xl border border-slate-200 bg-white">
                            <img className="h-44 w-full object-cover" src={post.imageUrl} alt="" />
                            <div className="p-5">
                                <p className="text-lg font-semibold text-slate-900">{post.title}</p>
                                <p className="mt-2 text-sm text-slate-500">{post.preview}</p>
                            </div>
                        </a>
                    ))}
                </div>
            </section>

            <section id="nosotros" className="bg-slate-50">
                <div className="mx-auto max-w-6xl px-4 py-20 sm:px-6">
                    <h2 className="text-3xl font-semibold text-slate-900">Nosotros</h2>
                    <p className="mt-4 max-w-3xl text-slate-600">
                        GotPay es una empresa mexicana certificada por Banco de México para operar CoDi®. Formada por expertos en
                        tecnología y medios de pago, desarrollamos la plataforma para que las empresas integren el cobro CoDi® a
                        sus procesos.
                    </p>
                </div>
            </section>

            <footer className="border-t border-slate-200 bg-white">
                <div className="mx-auto grid max-w-6xl gap-8 px-4 py-12 sm:px-6 md:grid-cols-3">
                    <div>
                        <img className="h-8" src="gplogo.png" alt="GotPay" />
                        <p className="mt-4 text-sm text-slate-500">
                            <a href="mailto:contacto@gotpaymx.com">contacto@gotpaymx.com</a>
                        </p>
                        <p className="text-sm text-slate-500">
                            <a href="tel:+525568111408">+52 55 6811 1408</a>
                        </p>
                    </div>
                    <div className="text-sm text-slate-600">
                        <p className="font-semibold text-slate-900">Empresa</p>
                        <div className="mt-3 space-y-2">
                            {navigation.map((item) => (
                                <a key={item.name} href={item.href} className="block hover:text-brand-700">
                                    {item.name}
                                </a>
                            ))}
                        </div>
                    </div>
                    <div className="text-sm text-slate-600">
                        <p className="font-semibold text-slate-900">Soporte</p>
                        <Link to="/documentacion" className="mt-3 block hover:text-brand-700">
                            Documentación de API
                        </Link>
                    </div>
                </div>
                <div className="border-t border-slate-100 py-6 text-center text-xs text-slate-400">
                    © {new Date().getFullYear()} GotPay SAS de CV. Todos los derechos reservados.
                    <button type="button" onClick={launchWhatsAppSignup} className="ml-3 text-slate-300">
                        Login with Facebook
                    </button>
                </div>
            </footer>
        </div>
    )
}
